import React, { useEffect, useState } from "react";
import api from "../../api";
import { useParams, useNavigate } from "react-router-dom";

export default function StudentExamResult() {
  const { id, type } = useParams();
  const nav = useNavigate();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // -----------------------------
  // LOAD RESULT
  // -----------------------------
  useEffect(() => {
    loadResult();
    // eslint-disable-next-line
  }, [id, type]);

  const loadResult = async () => {
    try {
      setLoading(true);

      let url = "";
      if (type === "practice") {
        url = `/student/practice/${id}/result`;
      } else if (type === "scholarship") {
        url = `/student/scholarship/${id}/result`;
      } else if (type === "mega") {
        url = `/student/mega-scholarship/${id}/result`;
      } else {
        throw new Error("Invalid exam type");
      }

      const res = await api.get(url);
      setData(res.data);
    } catch (err) {
      console.error(err);
      alert("Result not available");
      nav("/student/results");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p style={{ padding: 30 }}>Loading result...</p>;
  }

  if (!data) {
    return <p style={{ padding: 30 }}>No result data found.</p>;
  }

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardWrapper}>
          {/* ================= HEADER ================= */}
          <div style={headerStyle}>
            <img src="/logo.png" alt="EduAt10" style={logoStyle} />
            <h2 style={titleStyle}>📊 Exam Result</h2>
          </div>

          {/* ================= SUMMARY ================= */}
          <div style={summaryBox}>
            <p>
              <strong>Score:</strong> {data.score} / {data.total_questions}
            </p>

            {data.rank !== undefined && (
              <p>
                <strong>Rank:</strong>{" "}
                {data.rank === null ? "Not declared yet" : data.rank}
              </p>
            )}

            <p>
              <strong>Submitted At:</strong>{" "}
              {data.submitted_at
                ? new Date(data.submitted_at).toLocaleString()
                : "—"}
            </p>

            {data.time_taken_seconds && (
              <p>
                <strong>Time Taken:</strong>{" "}
                {Math.floor(data.time_taken_seconds / 60)}m{" "}
                {data.time_taken_seconds % 60}s
              </p>
            )}
          </div>

          {/* ================= QUESTION ANALYSIS ================= */}
          {Array.isArray(data.details) && data.details.length > 0 && (
            <>
              <h3 style={{ marginTop: 30 }}>🧠 Question-wise Analysis</h3>

              {data.details.map((q, i) => (
                <div key={i} style={questionCard}>
                  <strong>
                    Q{i + 1}. {q.question}
                  </strong>

                  <p>
                    <strong>Your Answer:</strong>{" "}
                    {q.student_answer || "Not Attempted"}
                  </p>

                  <p>
                    <strong>Correct Answer:</strong> {q.correct}
                  </p>

                  <p
                    style={{
                      color: q.is_correct ? "green" : "red",
                      fontWeight: 700,
                    }}
                  >
                    {q.is_correct ? "✔ Correct" : "✖ Wrong"}
                  </p>
                </div>
              ))}
            </>
          )}

          {/* ================= ACTIONS ================= */}
          <div style={actionRow}>
            {type === "mega" && (
              <button
                onClick={() => nav(`/student/mega/${id}/leaderboard`)}
                style={btnPrimary}
              >
                🏆 View Leaderboard
              </button>
            )}

            <button
              onClick={() => nav("/student/results")}
              style={btnSecondary}
            >
              ← Back to Results
            </button>

            <button
              onClick={() => nav("/user/dashboard")}
              style={btnSecondary}
            >
              ← Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ================= BACKGROUND ================= */
const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 20,
};

/* ================= WRAPPER ================= */
const cardWrapper = {
  maxWidth: 900,
  margin: "auto",
  background: "rgba(255,255,255,0.95)",
  borderRadius: 16,
  padding: 30,
};

/* ================= HEADER ================= */
const headerStyle = {
  textAlign: "center",
  marginBottom: 20,
};

const logoStyle = {
  width: 120,
  marginBottom: 6,
};

const titleStyle = {
  fontSize: 20,
  fontWeight: 800,
};

/* ================= SUMMARY ================= */
const summaryBox = {
  background: "#f8fafc",
  padding: 20,
  borderRadius: 12,
};

/* ================= QUESTION ================= */
const questionCard = {
  marginTop: 15,
  padding: 15,
  border: "1px solid #e5e7eb",
  borderRadius: 8,
};

/* ================= ACTIONS ================= */
const actionRow = {
  marginTop: 30,
  display: "flex",
  gap: 12,
  flexWrap: "wrap",
};

const btnPrimary = {
  padding: "10px 18px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};

const btnSecondary = {
  padding: "10px 18px",
  background: "#e2e8f0",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};
